// extracted by mini-css-extract-plugin
export default {"selectCustom":"modalApproveTm_selectCustom__NCYE9","selectInfo":"modalApproveTm_selectInfo__uCrxn","errorMessage":"modalApproveTm_errorMessage__I+g8f"};